<script setup>
import Button from '@components/forms/Button.vue'

defineProps(['data'])

const routeFor = (event) => `/tournament/${event.slug}`
</script>

<template>
	<div class="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
		<div class="flex flex-col gap-3 rounded-lg bg-black p-3" v-for="event in data.events" :key="event.slug">
			<div class="font-bold leading-tight text-white">{{ event.name }}</div>
			<div class="flex grow items-center justify-center overflow-hidden rounded-lg bg-[#161A25]">
				<img :src="event.poster || event.logo" :alt="event.name" class="aspect-video w-full object-cover" />
			</div>
			<Button class="primary solid thin wide sm:hidden" :to="routeFor(event)">View Event</Button>
			<Button class="primary solid thin wide hidden sm:block" :to="routeFor(event)">View Event Page</Button>
		</div>
	</div>
</template>
